import React, { Component } from 'react';
import { FormGroup, Col } from 'react-bootstrap';
import LoginContainer from '../../containers/LoginContainer';
import ForgetPasswordContainer from '../../containers/ForgetPassword/ForgetPasswordContainer';
import { generateURL } from '../../utils/helper';
import _ from 'lodash';
import { session } from '../../Service/APIService';

class DefaultPage extends Component {
  constructor(props) {
    super(props);
    this.state = { logo: '' };
  }

  componentDidMount() {
    const elem = document.querySelector('body');
    if (window.location.hostname.toLowerCase().includes('tqdigilytics')) {
      elem.setAttribute('class', 'background_img_tql');
    } else {
      const selected = this.adddynamicBackground();
      elem.setAttribute('class', `background_img ${selected}`);
    }

    this.fetchDefaultConfig();
  }

  adddynamicBackground = () => {
    const imgArray = [
      'img1',
      'img2',
      'img3',
      'img4',
      'img6',
      'img7',
      'img8',
      'img9',
    ];
    return _.sample(imgArray);
  };

  fetchDefaultConfig() {
    const GENERIC_URL = generateURL();
    const URL = `${GENERIC_URL}/app/SiteBrand/${window.location.host}`;
    fetch(URL)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ logo: data.result.logo });
        session.setConfig(data.result);
        const favicon = document.getElementById('favicon');
        favicon.href = data.result.faviIcon;
        document.title = data.result.faviIconText;
      })
      .catch((err) => console.log(err));
  }

  componentWillUnmount = () => {
    const elem = document.querySelector('body');
    elem.setAttribute('class', '');
  };

  render() {
    const isTPL = window.location.hostname
      .toLowerCase()
      .includes('tqdigilytics');
    const { pageFlag } = this.props;
    return (
      <div>
        <Col md={4} lg={4} />

        <Col md={4} sm={12} lg={4} xs={12} className="vertical_middle">
          <div className={isTPL ? 'grey-box' : 'box'}>
            <div className="box-body">
              <div className="form-group col-md-12">
                <FormGroup style={{ textAlign: 'center' }}>
                  <img
                    src={this.state.logo}
                    style={{
                      height: '40px',
                      width: '200px',
                      objectFit: 'fill',
                    }}
                    alt=""
                  />
                </FormGroup>
                {pageFlag ? (
                  <LoginContainer isTPL={isTPL} />
                ) : (
                  <ForgetPasswordContainer />
                )}
              </div>
            </div>
          </div>
        </Col>
      </div>
    );
  }
}

export default DefaultPage;
